import { sum } from 'lib/array/arrayUtils'

export function sumAccommodationViewTotal(offerView: App.Checkout.AccommodationOfferView): number {
  return sum<App.Checkout.AnyItemView>(offerView.itemViews, (item) => item.totals.price + item.totals.surcharge)
}

export function sumAccommodationViewsTotal(offerViews: Array<App.Checkout.AccommodationOfferView>): number {
  return sum(offerViews, view => sumAccommodationViewTotal(view))
}
